"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.availableIcons = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _Icon = _interopRequireDefault(require("./Icon.css"));

var _IconsMap = _interopRequireDefault(require("./IconsMap"));

var _ProductIconsMap = _interopRequireDefault(require("./ProductIconsMap"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var allIcons = _objectSpread({}, _IconsMap["default"], {}, _ProductIconsMap["default"]);

var availableIcons = Object.keys(allIcons);
exports.availableIcons = availableIcons;

var cx = _bind["default"].bind(_Icon["default"]);

var Icon = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      title = _ref.title,
      description = _ref.description,
      rest = _objectWithoutProperties(_ref, ["name", "style", "className", "title", "description"]);

  var classes = cx('toga-icon', "toga-icon-".concat(name), className);
  var ariaHidden = rest['aria-hidden'];
  var IconComponent = allIcons[name] || null; // TODO: Turn the icons title as required

  if (title === null && ariaHidden === undefined) {
    // eslint-disable-next-line no-console
    console.warn("Icon ".concat(name, " has no title. Consider adding a meaningful title for accessibility reasons."));
  }

  return /*#__PURE__*/_react["default"].createElement(IconComponent, _extends({
    className: classes,
    description: description,
    style: style,
    title: title
  }, rest));
};

Icon.propTypes = {
  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].object]),
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  name: _propTypes["default"].oneOf(availableIcons).isRequired,
  style: _propTypes["default"].shape({}),
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
Icon.defaultProps = {
  className: null,
  style: {},
  title: null,
  description: '',
  height: 24,
  width: 24
};
var _default = Icon;
exports["default"] = _default;